import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import settings from './modules/settings'
import user from './modules/user'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: { consolelanguagedata: '' },
  modules: {
    app,
    settings,
    user
  },
  mutations: {
    consolelanguagedatashow(state, n) {
      // 自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象)
      state.consolelanguagedata = JSON.parse(JSON.stringify(state.consolelanguagedata))
      state.consolelanguagedata = null
      state.consolelanguagedata = n
    }
  },
  getters
})

export default store
